(() => {
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const initialize = (section) => {
    if (!section || section.dataset.hairReady === 'true') return;

    const steps = [...section.querySelectorAll('[data-hair-step]')];
    const scenes = [...section.querySelectorAll('[data-hair-scene]')];
    if (!steps.length || steps.length !== scenes.length) return;

    section.dataset.hairReady = 'true';
    let activeIndex = -1;
    let ticking = false;

    const setActive = (index) => {
      if (index === activeIndex) return;
      activeIndex = index;

      steps.forEach((step, stepIndex) => {
        const active = stepIndex === index;
        step.classList.toggle('is-active', active);
        if (active) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });

      scenes.forEach((scene, sceneIndex) => {
        const active = sceneIndex === index;
        scene.classList.toggle('is-active', active);
        scene.setAttribute('aria-hidden', String(!active));
      });
    };

    const update = () => {
      ticking = false;
      const rect = section.getBoundingClientRect();
      const scrollDistance = Math.max(section.offsetHeight - window.innerHeight, 1);
      const progress = clamp(-rect.top / scrollDistance, 0, 1);
      const index = Math.round(progress * (steps.length - 1));
      const lineProgress = steps.length > 1 ? (index / (steps.length - 1)) * 100 : 100;

      section.style.setProperty('--hair-progress', `${lineProgress}%`);
      setActive(index);
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  };

  document.querySelectorAll('[data-hair-story]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target.matches('[data-hair-story]') ? event.target : event.target.querySelector('[data-hair-story]'));
  });
})();
